export default __webpack_public_path__ + "0b3533998c264aea5fbd88c93978ae75.svg";